import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { TestSuiteTableFilterSchema } from './-zod-schema';
export const Route = createFileRoute('/_stacktrace/test-suites/_layout/')({
  validateSearch: zodValidator(TestSuiteTableFilterSchema)
});